package com.essntl.core.settings.data.supabase.configuration

import com.essntl.core.settings.domain.model.configuration.ConfigurationEmailModel
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonIgnoreUnknownKeys

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@JsonIgnoreUnknownKeys
data class ConfigurationEmailDto(
    val emails: EmailValuesDto,
    @SerialName("waypoint_template_ids")
    val waypointTemplateIds: WaypointTemplateValuesDto,
) {
    fun toModel() = ConfigurationEmailModel(
        from = emails.from,
        bcc = emails.bcc,
        replyTo = emails.replyTo,
        waypointSimpleTemplateId = waypointTemplateIds.simple,
        waypointMultiTemplateId = waypointTemplateIds.multi,
    )
}
